<template>
  <div v-if="promotion" class="activity-desc">
    <div v-if="promotion.type===1" class="active-type">
      活动内容：
    </div>
    <div v-else class="active-type">
      活动价：￥{{ promotion.activePrice }}
    </div>
    <div class="active-desc">
      <span class="start-time">开始时间：{{ promotion.startTime | dateformat('YYYY-MM-DD HH:mm:ss') }}</span>
      <span class="end-time">结束时间：{{ promotion.endTime | dateformat('YYYY-MM-DD HH:mm:ss') }}</span>
      <div v-if="promotion.type===1">
        <p v-for="(rule,index) in promotion.gradsRules" :key="index" class="gift">{{ rule }}</p>
      </div>
      <div v-else>
        <p>{{ promotion.businessPromotionItems }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['promotion'],
  // props: {
  //   promotion: {
  //     type: Object,
  //     required: true
  //   }
  // },
  data () {
    return {
    }
  },
  mounted () {
    // console.log(this.promotion, 'promotion')
  }
}
</script>
<style>
  .activity-desc {
    width: 700px;
    min-height: 80px;
    background-color: #e3e4e5;
    display: flex;
    margin: 30px 0 10px 0;
    overflow: hidden;
  }
  .activity-desc .active-type {
    height: 100%/1.5;
    padding: 0 5px;
    font-weight: bold;
  }
  .activity-desc .active-desc {
    font-size: 1.125rem;
    font-weight: normal;
  }
  .active-desc .gift {
    line-height: 15px;
  }
</style>
